import React from 'react';


const ServerError = () => {

    const style = {maxWidth: '520px'};

    return (
        <section className="hero is-fullheight alva-bg">
            <div className="hero-body">
                <div className="container">
                    <div className="content" style={style}>
                        <h4>Oupps... An error occurred.</h4>
                        <p>The server responded with status code <a href="https://en.wikipedia.org/wiki/List_of_HTTP_status_codes">500</a>, which is probably due to a temporary server error.</p>

                        <p>Please write to us and tell us what happened. The easiest way is to use the chat down in the right corner.</p>

                        <p>You can try to go back to <a href={'/o'}>home</a>, or try again later.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServerError;

